var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import "./InteractionControls.component.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMediaDevicesStore } from "../../store/media-devices.store";
import { useLocalMicIndicator } from "../../hooks/mic-indicator.hook";
import { useEffect, useState } from "react";
import { MenuButton } from "../menu-button/MenuButton.component";
import { useRemoteVideoStreamsStore } from "../../store/remote-video-streams.store";
import { usersService } from "../../../modules/multiplayer/UsersService";
import { MessageService } from "../../services/message.service";
import { useTranslation } from "react-i18next";
import { localStreamingService } from "../../../modules/multiplayer/peer";
import { roomService } from "../../../modules/room/RoomService";
import { useLocallyAvailableRoomsStore, useRoomsParticipantStore } from "../../store/session-rooms.store";
import { useScreenShareStore } from "../../store/screen-share.store";
import { modelPool } from "@modules/model";
const ttPos = "top-left";
export function InteractionControls({ transparent = true }) {
    var _a;
    const mediaDevices = useMediaDevicesStore();
    const isSpeaking = useLocalMicIndicator();
    const [myOwnSharedSurfaces, setMyOwnSharedSurfaces] = useState([]);
    const remoteStreams = useRemoteVideoStreamsStore((state) => state.remoteScreenStreams);
    const { t } = useTranslation();
    const roomsParticipantList = useRoomsParticipantStore((state) => state.roomsParticipantList);
    const screenShareSurfaces = useScreenShareStore((state) => state.screenShareSurfaces);
    const locallyAvailableRooms = useLocallyAvailableRoomsStore((state) => state.locallyAvailableRooms);
    useEffect(() => {
        localStreamingService.onUpdateDelegate.add(updateOwnSharedSurfaces);
        return () => {
            localStreamingService.onUpdateDelegate.remove(updateOwnSharedSurfaces);
        };
    }, []);
    const updateOwnSharedSurfaces = () => {
        setMyOwnSharedSurfaces(localStreamingService.getScreenStreams().map((s) => s.surfaceUid));
    };
    const getButtonClassNames = (showIndicator = false) => {
        let result = "icon-button";
        if (showIndicator) {
            result += " interaction-controls-button-speaking";
        }
        if (transparent) {
            result += " interaction-controls-button-transparent";
        }
        return result;
    };
    const screenShareClicked = (surfaceIndex) => __awaiter(this, void 0, void 0, function* () {
        if (screenShareSurfaces.length <= surfaceIndex) {
            throw new Error("Screen share surface not available");
        }
        if (myOwnSharedSurfaces.includes(screenShareSurfaces[surfaceIndex].surfaceModelUid)) {
            yield MessageService.showConfirmationYesNo(t("sessionview:confirm-msg-stop-screenshare", 'Do you want to stop sharing on "{{surfaceName}}"?', {
                surfaceName: screenShareSurfaces[surfaceIndex].surfaceModelName
            }), () => {
                localStreamingService.stopScreenStreaming(screenShareSurfaces[surfaceIndex].surfaceModelUid);
            });
        }
        else {
            localStreamingService.startScreenStreaming(screenShareSurfaces[surfaceIndex].surfaceModelUid).catch((error) => {
                if (!error.toString().includes("Permission denied")) {
                    console.error("Error starting screen stream", error);
                }
            });
        }
    });
    const subRoomClicked = (roomUid) => __awaiter(this, void 0, void 0, function* () {
        yield roomService.loadAndEnterSubRoom(roomUid);
    });
    const whoIsSharing = (surfaceUid) => {
        var _a, _b;
        const stream = remoteStreams.find((stream) => stream.surfaceUid === surfaceUid);
        if (stream) {
            const userName = (_b = (_a = usersService.getUserByClientId(stream.clientId)) === null || _a === void 0 ? void 0 : _a.customUsername) !== null && _b !== void 0 ? _b : stream.clientId;
            return userName !== null && userName !== void 0 ? userName : stream.clientId;
        }
        return undefined;
    };
    const getScreenShareOptions = () => {
        return screenShareSurfaces.map((surface, index) => {
            let displayName = surface.surfaceModelName;
            let className = "";
            let tooltip;
            let tooltipDisabled;
            if (myOwnSharedSurfaces.find((s) => s === surface.surfaceModelUid) !== undefined) {
                displayName += " (" + t("sessionview:screenshare-menu-list-owned-surface-suffix", "mine") + ")";
                className = "interaction-controls-sharing-option-mine";
                tooltip = t("sessionview:screenshare-menu-list-stop-sharing-on-surface-tooltip", "Click to stop sharing on this surface");
            }
            else {
                const userName = whoIsSharing(surface.surfaceModelUid);
                displayName += userName ? ` (${userName})` : "";
                tooltipDisabled = t("sessionview:screenshare-menu-list-surface-in-use-tooltip", "This surface is already in use");
            }
            return {
                text: displayName,
                onClick: () => __awaiter(this, void 0, void 0, function* () {
                    yield screenShareClicked(index);
                }),
                disabled: remoteStreams.some((stream) => stream.surfaceUid === surface.surfaceModelUid),
                className: className,
                tooltip: tooltip,
                tooltipDisabled: tooltipDisabled,
                tooltipPosition: "bottom-left"
            };
        });
    };
    const getParticipantsInRoom = (roomUid) => {
        return roomsParticipantList.filter((sessionMemberInRoom) => {
            return sessionMemberInRoom.roomUid === roomUid;
        });
    };
    const getNumberOfParticipantsInRoom = (roomUid) => {
        return roomUid === undefined ? 0 : getParticipantsInRoom(roomUid).length;
    };
    const getSubRoomOptions = () => {
        return locallyAvailableRooms
            .map((room) => {
            const numberOfParticipants = getNumberOfParticipantsInRoom(room.roomUid);
            let displayName = ``;
            if (numberOfParticipants === 0) {
                displayName = `${room.roomName}`;
            }
            else if (numberOfParticipants > 0) {
                displayName = `${room.roomName} (${numberOfParticipants})`;
            }
            return {
                text: displayName,
                onClick: () => __awaiter(this, void 0, void 0, function* () {
                    yield subRoomClicked(room.roomUid);
                }),
                disabled: undefined,
                className: undefined,
                tooltip: undefined,
                icon: numberOfParticipants === 0 ? "dungeon" : "users",
                tooltipDisabled: undefined,
                tooltipPosition: "bottom-left",
                sortValue: numberOfParticipants
            };
            // first sort by name and then by number of participants
        })
            .sort((a, b) => {
            return !a.divider && !b.divider ? a.text.localeCompare(b.text) : 0;
        })
            .sort((a, b) => {
            var _a, _b;
            return !a.divider && !b.divider ? ((_a = b.sortValue) !== null && _a !== void 0 ? _a : 0) - ((_b = a.sortValue) !== null && _b !== void 0 ? _b : 0) : 0;
        });
    };
    const getScreenShareMenuTooltip = () => {
        if (myOwnSharedSurfaces.length === 0) {
            return t("sessionview:button-screenshare-menu-none-owned-tooltip", "Manage screen shares");
        }
        if (myOwnSharedSurfaces.length === 1) {
            return t("sessionview:button-screenshare-menu-one-owned-tooltip", "Manage screen shares\n(1 screen currently shared by you)");
        }
        return t("sessionview:button-screenshare-menu-many-owned-tooltip", "Manage screen shares\n({{num}} screens currently shared by you)", {
            num: myOwnSharedSurfaces.length
        });
    };
    const currentRoom = modelPool.getModel(roomService.currentRoomModelUID);
    return (React.createElement("div", { className: "interaction-controls-container" },
        screenShareSurfaces.length === 1 && (React.createElement("button", { className: `${getButtonClassNames()} ${myOwnSharedSurfaces.length > 0 ? "interaction-controls-button-sharing" : ""}`, onClick: () => __awaiter(this, void 0, void 0, function* () {
                yield screenShareClicked(0);
            }), disabled: remoteStreams.some((stream) => stream.surfaceUid === screenShareSurfaces[0].surfaceModelUid), "data-tooltip": myOwnSharedSurfaces.length > 0
                ? t("sessionview:button-stop-screenshare-tooltip", "Stop sharing your screen")
                : t("sessionview:button-start-screenshare-tooltip", "Share your screen"), "data-tooltip-disabled": t("sessionview:button-screenshare-tooltip-disabled", "Screen is currently being shared by {{userName}}", {
                userName: whoIsSharing(screenShareSurfaces[0].surfaceModelUid)
            }), "data-tooltip-position": ttPos },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "desktop"] }))),
        screenShareSurfaces.length > 1 && (React.createElement(MenuButton, { icon: "desktop", closeOnSelect: true, menuPlacement: "top-left", menuTitle: t("sessionview:button-screenshare-menu-title", "Select surface to share on"), options: getScreenShareOptions(), buttonClassName: myOwnSharedSurfaces.length > 0 ? "interaction-controls-button-sharing" : "", tooltip: getScreenShareMenuTooltip(), tooltipPosition: ttPos })),
        React.createElement("button", { className: getButtonClassNames(), onClick: () => {
                mediaDevices.cam.setEnabled(!mediaDevices.cam.enabled);
            }, "data-tooltip": mediaDevices.cam.enabled
                ? t("sessionview:button-camera-turn-off-tooltip", "Turn off your camera")
                : t("sessionview:button-camera-turn-on-tooltip", "Turn on your camera"), "data-tooltip-position": ttPos },
            React.createElement(FontAwesomeIcon, { icon: ["fas", mediaDevices.cam.enabled ? "video" : "video-slash"] })),
        React.createElement("button", { className: getButtonClassNames(isSpeaking && mediaDevices.mic.enabled), onClick: () => {
                mediaDevices.mic.setEnabled(!mediaDevices.mic.enabled);
            }, "data-tooltip": mediaDevices.mic.enabled
                ? t("sessionview:button-microphone-turn-off-tooltip", "Turn off your microphone")
                : t("sessionview:button-microphone-turn-on-tooltip", "Turn on your microphone"), "data-tooltip-position": ttPos },
            React.createElement(FontAwesomeIcon, { icon: ["fas", mediaDevices.mic.enabled ? "microphone" : "microphone-slash"] })),
        React.createElement("button", { className: getButtonClassNames(), onClick: () => {
                mediaDevices.speaker.setEnabled(!mediaDevices.speaker.enabled);
            }, "data-tooltip": mediaDevices.speaker.enabled
                ? t("sessionview:button-speakers-turn-off-tooltip", "Turn off your speakers")
                : t("sessionview:button-speakers-turn-on-tooltip", "Turn on your speakers"), "data-tooltip-position": ttPos },
            React.createElement(FontAwesomeIcon, { icon: ["fas", mediaDevices.speaker.enabled ? "volume-up" : "volume-mute"] })),
        locallyAvailableRooms.length > 0 && (React.createElement(MenuButton, { icon: "person-booth", closeOnSelect: true, menuPlacement: "top-left", menuTitle: t("sessionview:button-room-subspace-select", "Select subspace to join"), options: getSubRoomOptions(), tooltip: t("sessionview:button-room-subspace-tooltip", "Select subspace"), tooltipPosition: ttPos })),
        (currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.isRoom()) && currentRoom.getRoomDepth() > 0 && (React.createElement("button", { className: getButtonClassNames(), onClick: () => {
                roomService.exitCurrentRoom();
            }, "data-tooltip": t("sessionview:button-leave-current-room", "Leave the current room").concat(...[" (", getNumberOfParticipantsInRoom((_a = currentRoom === null || currentRoom === void 0 ? void 0 : currentRoom.getRoom()) === null || _a === void 0 ? void 0 : _a.getUID()).toString(), " user(s))"]), "data-tooltip-position": ttPos },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "person-walking-dashed-line-arrow-right"] })))));
}
